import type { CodeLanguage } from './types';

type RawCase = [input: string, expected: string];

const caseSeeds: Record<number, RawCase[]> = {
  1: [['6\n8 3 6 2 7 4\n10', '0 3'], ['2\n3 3\n6', '0 1'], ['4\n-3 4 3 90\n0', '0 2']],
  2: [['5\n2 4 7 11 15\n15', '2 4'], ['2\n2 3\n5', '1 2'], ['5\n1 2 3 4 6\n6', '2 4']],
  3: [['abcabcbb', '3'], ['bbbbb', '1'], ['pwwkew', '3']],
  4: [['-2 0 3 -5 2 -1\n0 2\n2 5', '1\n-1'], ['5\n0 0', '5'], ['1 2 3 4\n1 3\n0 2', '9\n6']],
  5: [['anagram\nnagaram', 'true'], ['rat\ncar', 'false'], ['aacc\nccac', 'false']],
  6: [['({[]})', 'true'], ['([)]', 'false'], ['{[]}', 'true']],
  7: [['8\n1 3 -1 -3 5 3 6 7\n3', '3 3 5 5 6 7'], ['2\n1 -1\n1', '1 -1'], ['5\n9 8 7 6 5\n2', '9 8 7 6']],
  8: [['4\n1 2 3 4', '4 3 2 1'], ['1\n7', '7'], ['5\n-1 0 2 2 9', '9 2 2 0 -1']],
  9: [['7\n4 5 6 7 0 1 2\n0', '4'], ['1\n1\n0', '-1'], ['6\n6 7 1 2 3 4\n7', '1']],
  10: [['3\n1 2 3', '[[],[1],[1,2],[1,2,3],[1,3],[2],[2,3],[3]]'], ['1\n0', '[[],[0]]'], ['2\n-1 2', '[[],[-1],[-1,2],[2]]']],
  11: [['6\n2 0 2 1 1 0', '0 0 1 1 2 2'], ['3\n2 2 2', '2 2 2'], ['5\n1 0 1 0 2', '0 0 1 1 2']],
  12: [['3 9 20 null null 15 7', '3'], ['1 null 2 null 3', '3'], ['null', '0']],
  13: [['5 1 4 null null 3 6', 'false'], ['2 1 3', 'true'], ['5 4 6 null null 3 7', 'false']],
  14: [['6\n3 2 1 5 6 4\n2', '5'], ['1\n8\n1', '8'], ['9\n3 2 3 1 2 4 5 5 6\n4', '4']],
  15: [['eat tea tan ate nat bat', '[[ate,eat,tea],[bat],[nat,tan]]'], ['abc', '[[abc]]'], ['a a b', '[[a,a],[b]]']],
  16: [['110\n100\n001', '2'], ['111\n111', '1'], ['000\n000', '0']],
  17: [['1,3;2,6;8,10;15,18', '1,6;8,10;15,18'], ['1,4;4,5', '1,5'], ['1,2;3,4', '1,2;3,4']],
  18: [['100 4 200 1 3 2', '4'], ['0 0', '1'], ['9 1 4 7 3 -1 0 5 8 -1 6', '7']],
  19: [['2 3 6 7\n7', '[[2,2,3],[7]]'], ['2 3 5\n8', '[[2,2,2,2],[2,3,3],[3,5]]'], ['7\n6', '[]']],
  20: [['2,4;1,3;2,4;1,3', '2,4;1,3;2,4;1,3'], ['2;1', '2;1'], ['', '']],
  21: [['4\n1,0;2,0;3,1;3,2', '0 1 2 3'], ['2\n1,0', '0 1'], ['2\n0,1;1,0', '']],
  22: [['5\n0,1;1,2;3,4', '2'], ['4\n', '4'], ['6\n0,1;1,2;2,0;3,4', '3']],
  23: [['2,1,1;2,3,1;3,4,1\n4\n2', '2'], ['1,2,1\n2\n1', '1'], ['1,2,1\n2\n2', '-1']],
  24: [['3 5 1 6 2 0 8 null null 7 4\n5 1', '3'], ['3 5 1 6 2 0 8 null null 7 4\n5 4', '5'], ['2 1\n1 2', '2']],
  25: [['insert apple\nsearch apple\nsearch app\nprefix app', 'true\nfalse\ntrue'], ['insert app\nsearch app', 'true'], ['insert hello\nprefix help', 'false']],
  26: [['2 7 9 3 1', '12'], ['1 2 3 1', '4'], ['2 1 1 2', '4']],
  27: [['000\n010\n000', '2'], ['01', '0'], ['0000', '1']],
  28: [['1 2 5\n11', '3'], ['2\n3', '-1'], ['1\n0', '0']],
  29: [['10 9 2 5 3 7 101 18', '4'], ['0 1 0 3 2 3', '4'], ['7 7 7 7', '1']],
  30: [['2 3 1 1 4', 'true'], ['3 2 1 0 4', 'false'], ['0', 'true']],
  31: [['4 1 2 1 2', '4'], ['2 2 1', '1'], ['-1 5 5', '-1']],
  32: [['10', '4'], ['0', '0'], ['100', '25']],
  33: [['1 3 5\nsum 0 2\nupdate 1 2\nsum 0 2', '9\n8'], ['0\nsum 0 0', '0'], ['2 4 6\nupdate 0 5\nsum 0 1', '9']],
  34: [['ADOBECODEBANC\nABC', 'BANC'], ['a\na', 'a'], ['a\naa', '']],
  35: [['hit\ncog\nhot dot dog lot log cog', '5'], ['hit\ncog\nhot dot dog lot log', '0'], ['a\nc\na b c', '2']],
  36: [['horse\nros', '3'], ['intention\nexecution', '5'], ['abc\nabc', '0']],
  37: [['1 2 3 4', '24 12 8 6'], ['-1 1 0 -3 3', '0 0 9 0 0'], ['2 3', '3 2']],
  38: [['1 2 3 null null 4 5', '1 2 null null 3 4 null null 5 null null'], ['null', 'null'], ['1 2 null 3', '1 2 3 null null null null']],
  59: [['1 3\n2', '2.0'], ['1 2\n3 4', '2.5'], ['0 0\n0 0', '0.0']],
};

export function getJudgeCases(day: number) {
  return (caseSeeds[day] ?? []).map(([input, expected], index) => ({
    label: index === 0 ? 'Example' : index === 1 ? 'Edge case' : 'Validation',
    input,
    expected,
    hidden: index === 2,
  }));
}

export const starterCode: Record<CodeLanguage, string> = {
  Java: `import java.io.*;\nimport java.util.*;\n\npublic class Main {\n    public static void main(String[] args) throws Exception {\n        String input = new String(System.in.readAllBytes()).trim();\n\n        // Parse input, solve the problem, and print only the answer.\n        // The exact stdin format is visible in each test case.\n\n    }\n}`,
  Python: `import sys\n\ndef solve(data: str):\n    # Parse input, solve the problem, and return the answer.\n    # The exact stdin format is visible in each test case.\n    pass\n\nif __name__ == "__main__":\n    data = sys.stdin.read().strip()\n    result = solve(data)\n    if result is not None:\n        print(result)`,
  JavaScript: `const fs = require('fs');\nconst input = fs.readFileSync(0, 'utf8').trim();\n\nfunction solve(data) {\n  // Parse input, solve the problem, and return the answer.\n  // The exact stdin format is visible in each test case.\n}\n\nconst result = solve(input);\nif (result !== undefined) console.log(result);`,
};
